import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-363" data-mp="3peam4j0ug885">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-navy-soft bg-navy-deep/95 px-4 py-2.5 backdrop-blur md:hidden" data-id="element-364" data-mp="3ud545iqzlsr7">
          <div className="flex items-center justify-between gap-3" data-id="element-365" data-mp="c5pi9o701cfb">
            <p className="text-[0.78rem] leading-tight text-white/70" data-id="element-366" data-mp="gyqxjxb4bdzf">
              Guía completa
              <span className="block text-sm font-semibold text-white" data-id="element-367" data-mp="76xdobkv6u5q">$6.39 · pago único</span>
            </p>
            <CtaButton size="md" label="LO QUIERO" scrollToId="precio" data-id="element-368" data-mp="2842ipt1vf8q" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}